import React from 'react';
import { Link } from 'gatsby';
import logo from '../images/dt-logo.svg';
import ig from '../images/instagram.svg';
var Navigation = function Navigation(data) {
    return /*#__PURE__*/ React.createElement("nav", {
        className: "navigation"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "navigation__container"
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/"
    }, /*#__PURE__*/ React.createElement("img", {
        className: "navigation__logo",
        alt: "Drew Templeton Logo",
        src: logo
    })), /*#__PURE__*/ React.createElement("a", {
        href: "https://instagram.com/drewbie613"
    }, /*#__PURE__*/ React.createElement("img", {
        className: "navigation__instagram",
        alt: "Drew Templeton Instagram",
        src: ig
    }))));
};
export default Navigation;
